import React from 'react';
import PropTypes from 'prop-types';
import {setConfiguration} from 'react-grid-system';

setConfiguration({
  breakpoints: [600, 960, 1280, 1920],
  gutterWidth: 0,
});

function AppContent(props) {
  const {children, classes} = props;

  return (
    <main className={classes.content}>
      <div className={classes.toolbar} />
      {children}
    </main>
  );
}

AppContent.propTypes = {
  children: PropTypes.element.isRequired,
  classes: PropTypes.shape({
    content: PropTypes.string,
    toolbar: PropTypes.string,
  }).isRequired,
};

export default AppContent;
